import * as types from "../constants/journal";
import { apiAction } from "../actions/api";
import { announce } from './announcements';
import { getJournalPageName } from '../utils/page-names';

export const selectPage = (page) => (dispatch) => {
  dispatch({
    type: types.JOURNAL_SELECT_PAGE,
    page
  });

  // Only announce immediately for pages that don't use iframes
  // Introduction and Design Challenge load via iframe, so they'll announce when loaded
  // Gradebook, Logs, and Reflection are components that load immediately
  const immediatePages = [
    types.JOURNAL_GRADEBOOK,
    types.JOURNAL_LOGS,
    types.JOURNAL_REFLECTION
  ];

  if (immediatePages.includes(page)) {
    const pageName = getJournalPageName(page);
    dispatch(announce(`${pageName} page loaded`));
  }
};

export const loadJournal = journal => ({
  type: types.JOURNAL_LOAD,
  journal
});

export const selectConcept = conceptName => (dispatch, getState) => {
  let concept, revisionId;
  if (conceptName) {
    concept = getState().filemanager.concepts.find(c => c.name === conceptName);
  }

  if (concept) {
    revisionId = concept.revisions[0].id;
  }

  dispatch({
    type: types.JOURNAL_SELECT_REVISION,
    conceptName,
    revisionId
  });
};

export const selectRevision = (revisionId, conceptName = null) => (
  dispatch,
  getState
) => {
  if (revisionId && conceptName === null) {
    // find the revision so we can get the conceptName
    const r = getState().filemanager.revisions.find(r => r.id === revisionId);
    if (r) {
      conceptName = r.name;
    }
  }

  dispatch({
    type: types.JOURNAL_SELECT_REVISION,
    revisionId,
    conceptName
  });
};

export const toggleDesignSummary = show => ({
  type: types.JOURNAL_TOGGLE_DESIGN_SUMMARY,
  show
});

export const saveJournalSection = (section, content) => dispatch => {
  return dispatch(
    apiAction(
      [
        types.JOURNAL_SAVE,
        types.JOURNAL_SAVE_SUCCESS,
        types.JOURNAL_SAVE_FAILURE
      ],
      api => api.saveJournalSection(section, content)
    )
  );
};
